import { searchActionTypes } from "./search.types";
import { Search } from "../../services/api/search-api";

export const setSearchInput = (input) => ({
    type: searchActionTypes.SET_SEARCH_INPUT,
    payload: input
});

export const setSearchResult = (result) => ({
    type: searchActionTypes.SET_SEARCH_RESULT,
    payload: result
});

export const setSearchResultSorted = (resultSorted) => ({
    type: searchActionTypes.SET_SEARCH_RESULT_SORTED,
    payload: resultSorted
});

export const searchLoadingStart = () => ({
    type: searchActionTypes.SEARCH_LOADING_START
});

export const searchLoadingFinish = () => ({
    type: searchActionTypes.SEARCH_LOADING_FINISH
});

export const searchLoadingFailure = (error) => ({
    type: searchActionTypes.SEARCH_LOADING_FAILURE,
    payload: error
});

const processResult = (result, input) => {
    let name = result.Name.length <= 25 ? result.Name : result.Name.slice(0, 23) + '...';
    let nameArray = [];

    if (result.Location.includes('Project Name')) {
        nameArray = result.Name.toLowerCase().split(input);
    }

    return {
        ...result,
        nameArray: nameArray,
        nameShort: name,
        doc: result.Type === 'Document Task',
        title: getResultTitle(result)
    };
};

const getResultTitle = (result) => {
    if (result.Type === 'Project') return 'Project';
    if (result.Type === 'Regular Task') return 'Task';
    return result.DocumentType;
};

const addToResults = ({result, projects, wordDocs, excelDocs, pptDocs, tasks, auditTrail, input}) => {
    const resultType = result.Type;
    const location = result.Location;
    const docType = result.DocumentType;

    switch (resultType) {
        case 'Project':
            projects.push(processResult(result, input));
            break;
        case 'Regular Task':
            tasks.push(processResult(result, input));
            break;
        case 'Document Task':
            if (docType === 'Word') wordDocs.push(processResult(result, input));
            else if (docType === 'Excel') excelDocs.push(processResult(result, input));
            else if (docType === 'PowerPoint') pptDocs.push(processResult(result, input));
            break;
        default:
            if (location === 'Description/Comments') auditTrail.push(processResult(result, input));
            break;
    }
};

export const getSearchResults = (input) => {
    return async (dispatch, getState) => {
        try {
            dispatch(setSearchInput(input));
            dispatch(searchLoadingStart());

            const results = (await Search(input)).data;

            dispatch(setSearchResult(results));

            let projects = [];
            let wordDocs = [];
            let excelDocs = [];
            let pptDocs = [];
            let tasks = [];
            let auditTrail = [];

            results.forEach(result => {
                addToResults({result, projects, wordDocs, excelDocs, pptDocs, tasks, auditTrail, input});
            });

            const resultSorted = {
                wordDocs,
                excelDocs,
                pptDocs,
                projects,
                tasks,
                auditTrail
            };

            dispatch(setSearchResultSorted(resultSorted));
            dispatch(searchLoadingFinish());
        } catch (error) {
            dispatch(searchLoadingFailure(error));
            console.log(error);
        }
    };
};